<script>

import AvaliacaoHeader from './Header'
import AvaliacaoTermoAceite from './TermoAceite'
import AvaliacaoRedacao from './Redacao'
import AvaliacaoTema from './Tema'
import AvaliacaoConfirmacao from './Confirmacao'
import AvaliacaoErro from './Erro'
import * as avaliacaoService from '../services/avaliacaoService'
import AppContentLoader from '../../../components/main/ContentLoader'

export default {
  components: {
    AppContentLoader,
    AvaliacaoErro,
    AvaliacaoConfirmacao,
    AvaliacaoTema,
    AvaliacaoRedacao,
    AvaliacaoTermoAceite,
    AvaliacaoHeader
  },
  data () {
    return {
      avaliacao: {
        pessoa: {
          id: null,
          nome: '',
          sigla: ''
        },
        temas: [],
        tema: null,
        redacao: {
          titulo: '',
          texto: ''
        }
      },
      etapa: null,
      isLoading: true
    }
  },
  async mounted () {
    if (!this.$route.query.avaliacao) {
      this.etapa = 'erro'
      this.isLoading = false

      return
    }

    try {
      const avaliacao = await avaliacaoService.buscarAvaliacaoPeloHash(this.$route.query.avaliacao)

      this.avaliacao = {...this.avaliacao, ...avaliacao}

      if (avaliacao.fl_finalizada) {
        this.etapa = 'erro'
      } else if (avaliacao.fl_pular_aceite) {
        this.etapa = 'tema'
      } else {
        this.etapa = 'termo-aceite'
      }
    } catch (error) {
      this.etapa = 'erro'
    }

    this.isLoading = false
  },
  methods: {}
}
</script>
<template>
  <div class="avaliacao-wrapper">
    <avaliacao-header :pessoa="avaliacao.pessoa"/>
    <div class="avaliacao-content" v-if="etapa">
      <avaliacao-termo-aceite :etapa.sync="etapa" v-if="etapa === 'termo-aceite'"/>
      <avaliacao-tema :avaliacao.sync="avaliacao" :etapa.sync="etapa" v-if="etapa === 'tema'"/>
      <avaliacao-redacao :avaliacao.sync="avaliacao"
                         :etapa.sync="etapa"
                         :is-loading.sync="isLoading"
                         v-if="etapa === 'redacao'"/>
      <avaliacao-confirmacao v-if="etapa === 'confirmacao'"/>
      <avaliacao-erro v-if="etapa === 'erro'"/>
    </div>
    <app-content-loader :is-loading.sync="isLoading"/>
  </div>
</template>
<style lang="scss">
.avaliacao-wrapper {
  width: 100%;
}

.avaliacao-content {
  margin: 0 auto 200px;
  padding: 32px 16px;
  max-width: 960px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?2d0b1a65